import React from 'react';

const MiniJackpotAmount = ({ formattedMegaJackpot, formattedMiniJackpot }) => (
<>
<div className="wheel-jackpot-amount">
<svg id="wheel-jackpot-svg-bottom" className="jackpot-svg " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 358.06 96.4" width="100%" height="100%">
<defs>
<style>{`
#wheel-jackpot-svg-bottom .cls-1 {
fill: url(#wheel-radial-gradient-44);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-1, #wheel-jackpot-svg-bottom .cls-2, #wheel-jackpot-svg-bottom .cls-3, #wheel-jackpot-svg-bottom .cls-4, #wheel-jackpot-svg-bottom .cls-5, #wheel-jackpot-svg-bottom .cls-6, #wheel-jackpot-svg-bottom .cls-7, #wheel-jackpot-svg-bottom .cls-8, #wheel-jackpot-svg-bottom .cls-9, #wheel-jackpot-svg-bottom .cls-10, #wheel-jackpot-svg-bottom .cls-11, #wheel-jackpot-svg-bottom .cls-12, #wheel-jackpot-svg-bottom .cls-13, #wheel-jackpot-svg-bottom .cls-14, #wheel-jackpot-svg-bottom .cls-15, #wheel-jackpot-svg-bottom .cls-16, #wheel-jackpot-svg-bottom .cls-17, #wheel-jackpot-svg-bottom .cls-18, #wheel-jackpot-svg-bottom .cls-19, #wheel-jackpot-svg-bottom .cls-20, #wheel-jackpot-svg-bottom .cls-21, #wheel-jackpot-svg-bottom .cls-22, #wheel-jackpot-svg-bottom .cls-23, #wheel-jackpot-svg-bottom .cls-24, #wheel-jackpot-svg-bottom .cls-25, #wheel-jackpot-svg-bottom .cls-26, #wheel-jackpot-svg-bottom .cls-27, #wheel-jackpot-svg-bottom .cls-28, #wheel-jackpot-svg-bottom .cls-29, #wheel-jackpot-svg-bottom .cls-30, #wheel-jackpot-svg-bottom .cls-31, #wheel-jackpot-svg-bottom .cls-32, #wheel-jackpot-svg-bottom .cls-33, #wheel-jackpot-svg-bottom .cls-34, #wheel-jackpot-svg-bottom .cls-35, #wheel-jackpot-svg-bottom .cls-36, #wheel-jackpot-svg-bottom .cls-37, #wheel-jackpot-svg-bottom .cls-38, #wheel-jackpot-svg-bottom .cls-39, #wheel-jackpot-svg-bottom .cls-40, #wheel-jackpot-svg-bottom .cls-41, #wheel-jackpot-svg-bottom .cls-42, #wheel-jackpot-svg-bottom .cls-43, #wheel-jackpot-svg-bottom .cls-44, #wheel-jackpot-svg-bottom .cls-45, #wheel-jackpot-svg-bottom .cls-46, #wheel-jackpot-svg-bottom .cls-47 {
isolation: isolate;
}

#wheel-jackpot-svg-bottom .cls-1, #wheel-jackpot-svg-bottom .cls-4, #wheel-jackpot-svg-bottom .cls-5, #wheel-jackpot-svg-bottom .cls-6, #wheel-jackpot-svg-bottom .cls-10, #wheel-jackpot-svg-bottom .cls-13, #wheel-jackpot-svg-bottom .cls-14, #wheel-jackpot-svg-bottom .cls-15, #wheel-jackpot-svg-bottom .cls-17, #wheel-jackpot-svg-bottom .cls-21, #wheel-jackpot-svg-bottom .cls-24, #wheel-jackpot-svg-bottom .cls-25, #wheel-jackpot-svg-bottom .cls-26, #wheel-jackpot-svg-bottom .cls-28, #wheel-jackpot-svg-bottom .cls-29, #wheel-jackpot-svg-bottom .cls-30, #wheel-jackpot-svg-bottom .cls-31, #wheel-jackpot-svg-bottom .cls-48, #wheel-jackpot-svg-bottom .cls-36, #wheel-jackpot-svg-bottom .cls-37, #wheel-jackpot-svg-bottom .cls-38, #wheel-jackpot-svg-bottom .cls-39, #wheel-jackpot-svg-bottom .cls-44, #wheel-jackpot-svg-bottom .cls-46 {
mix-blend-mode: screen;
}

#wheel-jackpot-svg-bottom .cls-49 {
fill: url(#wheel-linear-gradient-15);
}

#wheel-jackpot-svg-bottom .cls-50 {
fill: url(#wheel-linear-gradient-13);
}

#wheel-jackpot-svg-bottom .cls-2 {
fill: url(#wheel-radial-gradient-29);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-2, #wheel-jackpot-svg-bottom .cls-3, #wheel-jackpot-svg-bottom .cls-7, #wheel-jackpot-svg-bottom .cls-8, #wheel-jackpot-svg-bottom .cls-9, #wheel-jackpot-svg-bottom .cls-11, #wheel-jackpot-svg-bottom .cls-12, #wheel-jackpot-svg-bottom .cls-16, #wheel-jackpot-svg-bottom .cls-18, #wheel-jackpot-svg-bottom .cls-19, #wheel-jackpot-svg-bottom .cls-20, #wheel-jackpot-svg-bottom .cls-23, #wheel-jackpot-svg-bottom .cls-27, #wheel-jackpot-svg-bottom .cls-32, #wheel-jackpot-svg-bottom .cls-33, #wheel-jackpot-svg-bottom .cls-34, #wheel-jackpot-svg-bottom .cls-35, #wheel-jackpot-svg-bottom .cls-40, #wheel-jackpot-svg-bottom .cls-41, #wheel-jackpot-svg-bottom .cls-42, #wheel-jackpot-svg-bottom .cls-43, #wheel-jackpot-svg-bottom .cls-45, #wheel-jackpot-svg-bottom .cls-47 {
mix-blend-mode: color-dodge;
}

#wheel-jackpot-svg-bottom .cls-3 {
fill: url(#wheel-radial-gradient-7);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-4 {
fill: url(#wheel-radial-gradient-16);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-5 {
fill: url(#wheel-radial-gradient-8);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-6 {
fill: url(#wheel-radial-gradient-12);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-7 {
fill: url(#wheel-radial-gradient-23);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-8 {
fill: url(#wheel-radial-gradient-17);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-51 {
fill: url(#wheel-linear-gradient-2);
}

#wheel-jackpot-svg-bottom .cls-52 {
fill: url(#wheel-linear-gradient-10);
}

#wheel-jackpot-svg-bottom .cls-53 {
fill: url(#wheel-linear-gradient-12);
}

#wheel-jackpot-svg-bottom .cls-54 {
fill: #505050;
}

#wheel-jackpot-svg-bottom .cls-9 {
fill: url(#wheel-radial-gradient-43);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-55 {
fill: #9f9f9f;
}

#wheel-jackpot-svg-bottom .cls-10 {
fill: url(#wheel-radial-gradient-42);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-56 {
fill: #8f8f8f;
}

#wheel-jackpot-svg-bottom .cls-11 {
fill: url(#wheel-radial-gradient-27);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-57 {
fill: #fff;
}

#wheel-jackpot-svg-bottom .cls-12 {
fill: url(#wheel-radial-gradient-45);
}

#wheel-jackpot-svg-bottom .cls-13 {
fill: url(#wheel-radial-gradient-22);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-14 {
fill: url(#wheel-radial-gradient-36);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-15 {
fill: url(#wheel-radial-gradient-32);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-16 {
fill: url(#wheel-radial-gradient-37);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-58 {
fill: #606060;
}

#wheel-jackpot-svg-bottom .cls-59 {
fill: url(#wheel-linear-gradient-4);
}

#wheel-jackpot-svg-bottom .cls-60 {
fill: #303030;
}

#wheel-jackpot-svg-bottom .cls-17 {
fill: url(#wheel-radial-gradient-14);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-18 {
fill: url(#wheel-radial-gradient-15);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-19 {
fill: url(#wheel-radial-gradient-19);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-20 {
fill: url(#wheel-radial-gradient-5);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-61 {
fill: url(#wheel-linear-gradient-3);
}

#wheel-jackpot-svg-bottom .cls-62 {
fill: url(#wheel-linear-gradient-5);
}

#wheel-jackpot-svg-bottom .cls-63 {
fill: #404040;
}

#wheel-jackpot-svg-bottom .cls-21 {
fill: url(#wheel-radial-gradient-40);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-64 {
fill: url(#wheel-linear-gradient-22);
}

#wheel-jackpot-svg-bottom .cls-23 {
fill: url(#wheel-radial-gradient-33);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-24 {
fill: url(#wheel-radial-gradient-2);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-65 {
fill: #bfbfbf;
}

#wheel-jackpot-svg-bottom .cls-25 {
fill: url(#wheel-radial-gradient-18);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-66 {
fill: url(#wheel-linear-gradient-8);
}

#wheel-jackpot-svg-bottom .cls-67 {
fill: #202020;
}

#wheel-jackpot-svg-bottom .cls-26 {
fill: url(#wheel-radial-gradient-10);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-27 {
fill: url(#wheel-radial-gradient-11);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-28 {
fill: url(#wheel-radial-gradient-46);
}

#wheel-jackpot-svg-bottom .cls-29 {
fill: url(#wheel-radial-gradient-38);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-30 {
fill: url(#wheel-radial-gradient-4);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-68 {
fill: url(#wheel-linear-gradient-14);
}

#wheel-jackpot-svg-bottom .cls-31 {
fill: url(#wheel-radial-gradient-6);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-69 {
fill: url(#wheel-linear-gradient-20);
}

#wheel-jackpot-svg-bottom .cls-32 {
fill: url(#wheel-radial-gradient-39);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-70 {
fill: url(#wheel-linear-gradient-17);
}

#wheel-jackpot-svg-bottom .cls-33 {
fill: url(#wheel-radial-gradient-35);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-71 {
fill: url(#wheel-linear-gradient-7);
}

#wheel-jackpot-svg-bottom .cls-72 {
fill: #efefef;
}

#wheel-jackpot-svg-bottom .cls-73 {
fill: url(#wheel-linear-gradient-9);
}

#wheel-jackpot-svg-bottom .cls-74 {
fill: #dfdfdf;
}

#wheel-jackpot-svg-bottom .cls-34 {
fill: url(#wheel-radial-gradient);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-75, #wheel-jackpot-svg-bottom .cls-76 {
mix-blend-mode: multiply;
}

#wheel-jackpot-svg-bottom .cls-35 {
fill: url(#wheel-radial-gradient-13);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-77 {
fill: url(#wheel-linear-gradient-11);
}

#wheel-jackpot-svg-bottom .cls-36 {
fill: url(#wheel-radial-gradient-30);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-37 {
fill: url(#wheel-radial-gradient-20);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-78 {
fill: url(#wheel-linear-gradient-19);
}

#wheel-jackpot-svg-bottom .cls-38 {
fill: url(#wheel-radial-gradient-28);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-79 {
fill: url(#wheel-linear-gradient-6);
}

#wheel-jackpot-svg-bottom .cls-39 {
fill: url(#wheel-radial-gradient-24);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-80 {
fill: #cfcfcf;
}

#wheel-jackpot-svg-bottom .cls-40 {
fill: url(#wheel-radial-gradient-31);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-81 {
fill: url(#wheel-linear-gradient-21);
}

#wheel-jackpot-svg-bottom .cls-41 {
fill: url(#wheel-radial-gradient-41);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-42 {
fill: url(#wheel-radial-gradient-21);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-43 {
fill: url(#wheel-radial-gradient-9);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-82 {
fill: gray;
}

#wheel-jackpot-svg-bottom .cls-44 {
fill: url(#wheel-radial-gradient-26);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-83 {
fill: url(#wheel-linear-gradient-16);
}

#wheel-jackpot-svg-bottom .cls-84 {
fill: url(#wheel-linear-gradient);
}

#wheel-jackpot-svg-bottom .cls-45 {
fill: url(#wheel-radial-gradient-25);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-46 {
fill: url(#wheel-radial-gradient-34);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-bottom .cls-85 {
fill: #101010;
}

#wheel-jackpot-svg-bottom .cls-86 {
fill: #707070;
}

#wheel-jackpot-svg-bottom .cls-87 {
fill: url(#wheel-linear-gradient-18);
}

#wheel-jackpot-svg-bottom .cls-88 {
fill: #afafaf;
}

#wheel-jackpot-svg-bottom .cls-47 {
fill: url(#wheel-radial-gradient-3);
animation: blink 1s ease-in-out infinite;
}

@keyframes blink {
0%, 100% {
opacity: 1;
}
50% {
opacity: 0.3;
}
}

#wheel-jackpot-svg-bottom .cls-76 {
opacity: .5;
}
`}</style>
<linearGradient id="wheel-linear-gradient" x1="179.03" y1="266.49" x2="179.03" y2="179.61" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#ffc0c0"/>
<stop offset=".5" stop-color="red"/>
<stop offset="1" stop-color="maroon"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-2" x1="179.04" y1="265.13" x2="179.04" y2="180.97" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="red"/>
<stop offset="1" stop-color="maroon"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-3" x1="179.02" y1="189.1" x2="179.02" y2="256.98" href="#wheel-linear-gradient-2"/>
<linearGradient id="wheel-linear-gradient-4" x1="179.02" y1="190.47" x2="179.02" y2="255.63" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#b37920"/>
<stop offset=".19" stop-color="#ffda80"/>
<stop offset=".27" stop-color="#e6ba60"/>
<stop offset=".36" stop-color="#ce9a41"/>
<stop offset=".44" stop-color="#bf872d"/>
<stop offset=".5" stop-color="#ba8027"/>
<stop offset=".57" stop-color="#d0a758"/>
<stop offset=".65" stop-color="#e4cb85"/>
<stop offset=".72" stop-color="#f2e4a5"/>
<stop offset=".77" stop-color="#fbf4b8"/>
<stop offset=".81" stop-color="#fffac0"/>
<stop offset="1" stop-color="#fffac0"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-5" x1="179.02" y1="190.47" x2="179.02" y2="255.63" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#c78730"/>
<stop offset="1" stop-color="#682800"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-6" x1="179.03" y1="191.14" x2="179.03" y2="254.95" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#cb8f3d"/>
<stop offset="1" stop-color="#713510"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-7" x1="179.03" y1="191.82" x2="179.03" y2="254.27" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#ce964a"/>
<stop offset="1" stop-color="#7b4320"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-8" x1="179.03" y1="192.51" x2="179.03" y2="253.6" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#d29e57"/>
<stop offset="1" stop-color="#845030"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-9" x1="179.03" y1="193.19" x2="179.03" y2="252.92" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#d5a564"/>
<stop offset="1" stop-color="#8e5e40"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-10" x1="179.02" y1="193.86" x2="179.02" y2="252.24" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#d9ad71"/>
<stop offset="1" stop-color="#976b50"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-11" x1="179.02" y1="194.54" x2="179.02" y2="251.56" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#dcb47e"/>
<stop offset="1" stop-color="#a17960"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-12" x1="179.03" y1="195.22" x2="179.03" y2="250.88" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#e0bc8b"/>
<stop offset="1" stop-color="#aa8670"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-13" x1="179.03" y1="195.9" x2="179.03" y2="250.2" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#e3c398"/>
<stop offset="1" stop-color="#b39380"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-14" x1="179.03" y1="196.58" x2="179.03" y2="249.53" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#e7cba4"/>
<stop offset="1" stop-color="#bda18f"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-15" x1="179.03" y1="197.25" x2="179.03" y2="248.85" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#ead2b1"/>
<stop offset="1" stop-color="#c6ae9f"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-16" x1="179.02" y1="197.93" x2="179.02" y2="248.17" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#eedabe"/>
<stop offset="1" stop-color="#d0bcaf"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-17" x1="179.02" y1="198.61" x2="179.02" y2="247.49" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#f1e1cb"/>
<stop offset="1" stop-color="#d9c9bf"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-18" x1="179.02" y1="199.29" x2="179.02" y2="246.81" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#f5e9d8"/>
<stop offset="1" stop-color="#e3d7cf"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-19" x1="179.03" y1="199.97" x2="179.03" y2="246.13" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#f8f0e5"/>
<stop offset="1" stop-color="#ece4df"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-20" x1="179.02" y1="200.64" x2="179.02" y2="245.45" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#fcf8f2"/>
<stop offset="1" stop-color="#f6f2ef"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-21" x1="179.02" y1="201.33" x2="179.02" y2="244.78" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#fff"/>
<stop offset="1" stop-color="#fff"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-22" x1="180.13" y1="258.1" x2="180.13" y2="189.67" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#404040"/>
<stop offset="1" stop-color="#101010"/>
</linearGradient>
<radialGradient id="wheel-radial-gradient" cx="71.13" cy="261.04" fx="71.13" fy="261.04" r="13.56" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset=".13" stop-color="#fff"/>
<stop offset=".19" stop-color="#e6e6e6"/>
<stop offset=".36" stop-color="#a1a1a1"/>
<stop offset=".53" stop-color="#676767"/>
<stop offset=".68" stop-color="#3a3a3a"/>
<stop offset=".81" stop-color="#1a1a1a"/>
<stop offset=".92" stop-color="#070707"/>
<stop offset="1" stop-color="#000"/>
</radialGradient>
<radialGradient id="wheel-radial-gradient-2" cx="71.13" cy="261.04" fx="71.13" fy="261.04" r="13.56" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset=".13" stop-color="#fff"/>
<stop offset=".18" stop-color="#dadada"/>
<stop offset=".27" stop-color="#a7a7a7"/>
<stop offset=".36" stop-color="#7a7a7a"/>
<stop offset=".45" stop-color="#545454"/>
<stop offset=".54" stop-color="#353535"/>
<stop offset=".64" stop-color="#1e1e1e"/>
<stop offset=".75" stop-color="#0d0d0d"/>
<stop offset=".86" stop-color="#030303"/>
<stop offset="1" stop-color="#000"/>
</radialGradient>
<radialGradient id="wheel-radial-gradient-3" cx="92.71" cy="261.04" fx="92.71" fy="261.04" r="9.69" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-4" cx="92.71" cy="261.04" fx="92.71" fy="261.04" r="9.69" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-5" cx="114.29" cy="261.05" fx="114.29" fy="261.05" r="14.96" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-6" cx="114.29" cy="261.05" fx="114.29" fy="261.05" r="14.97" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-7" cx="135.88" cy="261.04" fx="135.88" fy="261.04" r="11.25" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-8" cx="135.88" cy="261.04" fx="135.88" fy="261.04" r="11.26" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-9" cx="157.45" cy="261.04" fx="157.45" fy="261.04" r="14.73" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-10" cx="157.45" fx="157.45" r="14.73" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-11" cx="179.04" cy="261.04" fx="179.04" fy="261.04" r="9.8" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-12" cx="179.04" cy="261.04" fx="179.04" fy="261.04" r="9.8" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-13" cx="200.61" cy="261.04" fx="200.61" fy="261.04" r="9" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-14" cx="200.61" cy="261.04" fx="200.61" fy="261.04" r="9" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-15" cx="222.19" cy="261.04" fx="222.19" fy="261.04" r="14.64" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-16" cx="222.19" cy="261.04" fx="222.19" fy="261.04" r="14.64" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-17" cx="243.77" cy="261.05" fx="243.77" fy="261.05" r="10.6" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-18" cx="243.76" cy="261.05" fx="243.76" fy="261.05" r="10.6" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-19" cx="265.35" cy="261.04" fx="265.35" fy="261.04" r="10.74" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-20" cx="265.35" cy="261.04" fx="265.35" fy="261.04" r="10.74" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-21" cx="286.94" cy="261.05" fx="286.94" fy="261.05" r="12.1" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-22" cx="286.94" cy="261.05" fx="286.94" fy="261.05" r="12.1" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-23" cx="308.5" cy="261.04" fx="308.5" fy="261.04" r="8.43" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-24" cx="308.5" cy="261.04" fx="308.5" fy="261.04" r="8.43" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-25" cx="49.56" cy="261.05" fx="49.56" fy="261.05" r="8.43" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-26" cx="49.56" cy="261.05" fx="49.56" fy="261.05" r="8.43" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-27" cx="346.54" cy="243.39" fx="346.54" fy="243.39" r="5.36" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-28" cx="346.54" cy="243.39" fx="346.54" fy="243.39" r="5.36" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-29" cx="351.82" cy="223.39" fx="351.82" fy="223.39" r="3.1" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-30" cx="351.81" cy="223.39" fx="351.81" fy="223.39" r="3.1" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-31" cx="345.86" cy="200.92" fx="345.86" fy="200.92" r="4.47" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-32" cx="345.86" cy="200.92" fx="345.86" fy="200.92" r="4.47" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-33" cx="331.05" cy="257.94" fx="331.05" fy="257.94" r="4.47" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-34" cx="331.05" cy="257.94" fx="331.05" fy="257.94" r="4.47" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-35" cx="329.07" cy="187.34" fx="329.07" fy="187.34" r="4.24" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-36" cx="329.07" cy="187.33" fx="329.07" fy="187.33" r="4.24" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-37" cx="-608.15" cy="243.39" fx="-608.15" fy="243.39" r="4.73" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-38" cx="-608.15" cy="243.39" fx="-608.15" fy="243.39" r="4.73" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-39" cx="-602.96" cy="223.39" fx="-602.96" fy="223.39" r="3.1" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-40" cx="-602.96" cy="223.39" fx="-602.96" fy="223.39" r="3.1" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-41" cx="-608.92" cy="200.92" fx="-608.92" fy="200.92" r="4.47" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-42" cx="-608.92" cy="200.92" fx="-608.92" fy="200.92" r="4.47" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-43" cx="-623.73" cy="257.94" fx="-623.73" fy="257.94" r="4.47" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-44" cx="-623.73" cy="257.94" fx="-623.73" fy="257.94" r="4.47" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-45" cx="-625.7" cy="187.34" fx="-625.7" fy="187.34" r="4.24" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-46" cx="-625.7" cy="187.33" fx="-625.7" fy="187.33" r="4.24" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient-2"/>
</defs>
<g class="cls-22">
<g id="Layer_2" data-name="Layer 2">
<g id="Layer_1-2" data-name="Layer 1">
<g>
<path class="cls-84" d="M358.06,52.96c0,23.99-19.45,43.44-43.44,43.44H43.44C19.45,96.4,0,76.95,0,52.96S19.45,9.52,43.44,9.52h271.18c23.99,0,43.44,19.45,43.44,43.44Z"/>
<path class="cls-51" d="M314.62,95.04H43.44C20.23,95.04,1.36,76.16,1.36,52.96S20.23,10.88,43.44,10.88h271.19c23.21,0,42.08,18.88,42.08,42.08s-18.87,42.08-42.08,42.08h-.01Z"/>
<path class="cls-61" d="M314.62,86.91H43.44c-18.72,0-33.94-15.23-33.94-33.95S24.72,19.03,43.44,19.03h271.18c18.71,0,33.93,15.22,33.93,33.93s-15.22,33.95-33.93,33.95h0Z"/>
<path class="cls-59" d="M314.62,20.38H43.44c-17.96,0-32.58,14.61-32.58,32.58s14.61,32.58,32.58,32.58h271.18c17.96,0,32.57-14.61,32.57-32.58s-14.61-32.58-32.57-32.58Z"/>
<g class="cls-75">
<g>
<path class="cls-62" d="M314.62,20.38H43.44c-17.96,0-32.58,14.61-32.58,32.58s14.61,32.58,32.58,32.58h271.18c17.96,0,32.57-14.61,32.57-32.58s-14.61-32.58-32.57-32.58Z"/>
<path class="cls-79" d="M314.62,21.06H43.44c-17.59,0-31.9,14.31-31.9,31.91s14.31,31.9,31.9,31.9h271.18c17.59,0,31.9-14.31,31.9-31.9s-14.31-31.91-31.9-31.91Z"/>
<path class="cls-71" d="M314.62,21.74H43.44c-17.21,0-31.22,14-31.22,31.23s14.01,31.22,31.22,31.22h271.18c17.21,0,31.22-14.01,31.22-31.22s-14-31.23-31.22-31.23Z"/>
<path class="cls-66" d="M314.62,22.41H43.44c-16.84,0-30.54,13.7-30.54,30.55s13.7,30.54,30.54,30.54h271.18c16.84,0,30.54-13.7,30.54-30.54s-13.7-30.55-30.54-30.55h0Z"/>
<path class="cls-73" d="M314.62,23.09H43.44c-16.46,0-29.86,13.4-29.86,29.87s13.4,29.86,29.86,29.86h271.18c16.47,0,29.86-13.4,29.86-29.86s-13.39-29.87-29.86-29.87Z"/>
<path class="cls-52" d="M314.62,23.77H43.44c-16.09,0-29.19,13.09-29.19,29.19s13.1,29.19,29.19,29.19h271.18c16.09,0,29.18-13.09,29.18-29.19s-13.09-29.19-29.18-29.19Z"/>
<path class="cls-77" d="M314.62,24.45H43.44c-15.72,0-28.51,12.79-28.51,28.51s12.79,28.51,28.51,28.51h271.18c15.72,0,28.5-12.79,28.5-28.51s-12.79-28.51-28.5-28.51Z"/>
<path class="cls-53" d="M314.62,25.13H43.44c-15.34,0-27.83,12.48-27.83,27.83s12.49,27.83,27.83,27.83h271.18c15.34,0,27.82-12.49,27.82-27.83s-12.48-27.83-27.82-27.83Z"/>
<path class="cls-50" d="M314.62,25.81H43.44c-14.97,0-27.15,12.18-27.15,27.15s12.18,27.15,27.15,27.15h271.18c14.97,0,27.15-12.18,27.15-27.15s-12.18-27.15-27.15-27.15Z"/>
<path class="cls-68" d="M314.62,26.48H43.44c-14.59,0-26.47,11.88-26.47,26.48s11.88,26.47,26.47,26.47h271.18c14.59,0,26.47-11.88,26.47-26.47s-11.87-26.48-26.47-26.48Z"/>
<path class="cls-49" d="M314.62,27.16H43.44c-14.22,0-25.8,11.57-25.8,25.8s11.58,25.8,25.8,25.8h271.18c14.22,0,25.79-11.58,25.79-25.8s-11.57-25.8-25.79-25.8Z"/>
<path class="cls-83" d="M314.62,27.84H43.44c-13.84,0-25.12,11.27-25.12,25.12s11.27,25.12,25.12,25.12h271.18c13.85,0,25.11-11.27,25.11-25.12s-11.26-25.12-25.11-25.12Z"/>
<path class="cls-70" d="M314.62,28.52H43.44c-13.47,0-24.44,10.97-24.44,24.44s10.97,24.44,24.44,24.44h271.18c13.47,0,24.43-10.97,24.43-24.44s-10.96-24.44-24.43-24.44Z"/>
<path class="cls-87" d="M314.62,29.2H43.44c-13.1,0-23.76,10.66-23.76,23.76s10.67,23.76,23.76,23.76h271.18c13.1,0,23.75-10.66,23.75-23.76s-10.65-23.76-23.75-23.76Z"/>
<path class="cls-78" d="M314.62,29.88H43.44c-12.72,0-23.08,10.36-23.08,23.08s10.36,23.08,23.08,23.08h271.18c12.72,0,23.07-10.36,23.07-23.08s-10.35-23.08-23.07-23.08Z"/>
<path class="cls-69" d="M314.62,30.56H43.44c-12.35,0-22.41,10.05-22.41,22.4s10.06,22.41,22.41,22.41h271.18c12.35,0,22.39-10.06,22.39-22.41s-10.05-22.4-22.39-22.4Z"/>
<path class="cls-81" d="M314.62,31.23H43.44c-11.97,0-21.73,9.75-21.73,21.72s9.75,21.73,21.73,21.73h271.18c11.97,0,21.72-9.75,21.72-21.73s-9.74-21.72-21.72-21.72Z"/>
</g>
<g class="cls-48">
<path d="M314.62,20.38H43.44c-17.96,0-32.58,14.61-32.58,32.58s14.61,32.58,32.58,32.58h271.18c17.96,0,32.57-14.61,32.57-32.58s-14.61-32.58-32.57-32.58Z"/>
<path class="cls-85" d="M314.62,21.06H43.44c-17.59,0-31.9,14.31-31.9,31.91s14.31,31.9,31.9,31.9h271.18c17.59,0,31.9-14.31,31.9-31.9s-14.31-31.91-31.9-31.91Z"/>
<path class="cls-67" d="M314.62,21.74H43.44c-17.21,0-31.22,14-31.22,31.23s14.01,31.22,31.22,31.22h271.18c17.21,0,31.22-14.01,31.22-31.22s-14-31.23-31.22-31.23Z"/>
<path class="cls-60" d="M314.62,22.41H43.44c-16.84,0-30.54,13.7-30.54,30.55s13.7,30.54,30.54,30.54h271.18c16.84,0,30.54-13.7,30.54-30.54s-13.7-30.55-30.54-30.55h0Z"/>
<path class="cls-63" d="M314.62,23.09H43.44c-16.46,0-29.86,13.4-29.86,29.87s13.4,29.86,29.86,29.86h271.18c16.47,0,29.86-13.4,29.86-29.86s-13.39-29.87-29.86-29.87Z"/>
<path class="cls-54" d="M314.62,23.77H43.44c-16.09,0-29.19,13.09-29.19,29.19s13.1,29.19,29.19,29.19h271.18c16.09,0,29.18-13.09,29.18-29.19s-13.09-29.19-29.18-29.19Z"/>
<path class="cls-58" d="M314.62,24.45H43.44c-15.72,0-28.51,12.79-28.51,28.51s12.79,28.51,28.51,28.51h271.18c15.72,0,28.5-12.79,28.5-28.51s-12.79-28.51-28.5-28.51Z"/>
<path class="cls-86" d="M314.62,25.13H43.44c-15.34,0-27.83,12.48-27.83,27.83s12.49,27.83,27.83,27.83h271.18c15.34,0,27.82-12.49,27.82-27.83s-12.48-27.83-27.82-27.83Z"/>
<path class="cls-82" d="M314.62,25.81H43.44c-14.97,0-27.15,12.18-27.15,27.15s12.18,27.15,27.15,27.15h271.18c14.97,0,27.15-12.18,27.15-27.15s-12.18-27.15-27.15-27.15Z"/>
<path class="cls-56" d="M314.62,26.48H43.44c-14.59,0-26.47,11.88-26.47,26.48s11.88,26.47,26.47,26.47h271.18c14.59,0,26.47-11.88,26.47-26.47s-11.87-26.48-26.47-26.48Z"/>
<path class="cls-55" d="M314.62,27.16H43.44c-14.22,0-25.8,11.57-25.8,25.8s11.58,25.8,25.8,25.8h271.18c14.22,0,25.79-11.58,25.79-25.8s-11.57-25.8-25.79-25.8Z"/>
<path class="cls-88" d="M314.62,27.84H43.44c-13.84,0-25.12,11.27-25.12,25.12s11.27,25.12,25.12,25.12h271.18c13.85,0,25.11-11.27,25.11-25.12s-11.26-25.12-25.11-25.12Z"/>
<path class="cls-65" d="M314.62,28.52H43.44c-13.47,0-24.44,10.97-24.44,24.44s10.97,24.44,24.44,24.44h271.18c13.47,0,24.43-10.97,24.43-24.44s-10.96-24.44-24.43-24.44Z"/>
<path class="cls-80" d="M314.62,29.2H43.44c-13.1,0-23.76,10.66-23.76,23.76s10.67,23.76,23.76,23.76h271.18c13.1,0,23.75-10.66,23.75-23.76s-10.65-23.76-23.75-23.76Z"/>
<path class="cls-74" d="M314.62,29.88H43.44c-12.72,0-23.08,10.36-23.08,23.08s10.36,23.08,23.08,23.08h271.18c12.72,0,23.07-10.36,23.07-23.08s-10.35-23.08-23.07-23.08Z"/>
<path class="cls-72" d="M314.62,30.56H43.44c-12.35,0-22.41,10.05-22.41,22.4s10.06,22.41,22.41,22.41h271.18c12.35,0,22.39-10.06,22.39-22.41s-10.05-22.4-22.39-22.4Z"/>
<path class="cls-57" d="M314.62,31.23H43.44c-11.97,0-21.73,9.75-21.73,21.72s9.75,21.73,21.73,21.73h271.18c11.97,0,21.72-9.75,21.72-21.73s-9.74-21.72-21.72-21.72Z"/>
</g>
</g>
<g class="cls-76">
<g>
<path class="cls-62" d="M314.62,20.38H43.44c-17.96,0-32.58,14.61-32.58,32.58s14.61,32.58,32.58,32.58h271.18c17.96,0,32.57-14.61,32.57-32.58s-14.61-32.58-32.57-32.58Z"/>
<path class="cls-79" d="M314.62,21.06H43.44c-17.59,0-31.9,14.31-31.9,31.91s14.31,31.9,31.9,31.9h271.18c17.59,0,31.9-14.31,31.9-31.9s-14.31-31.91-31.9-31.91Z"/>
<path class="cls-71" d="M314.62,21.74H43.44c-17.21,0-31.22,14-31.22,31.23s14.01,31.22,31.22,31.22h271.18c17.21,0,31.22-14.01,31.22-31.22s-14-31.23-31.22-31.23Z"/>
<path class="cls-66" d="M314.62,22.41H43.44c-16.84,0-30.54,13.7-30.54,30.55s13.7,30.54,30.54,30.54h271.18c16.84,0,30.54-13.7,30.54-30.54s-13.7-30.55-30.54-30.55h0Z"/>
<path class="cls-73" d="M314.62,23.09H43.44c-16.46,0-29.86,13.4-29.86,29.87s13.4,29.86,29.86,29.86h271.18c16.47,0,29.86-13.4,29.86-29.86s-13.39-29.87-29.86-29.87Z"/>
<path class="cls-52" d="M314.62,23.77H43.44c-16.09,0-29.19,13.09-29.19,29.19s13.1,29.19,29.19,29.19h271.18c16.09,0,29.18-13.09,29.18-29.19s-13.09-29.19-29.18-29.19Z"/>
<path class="cls-77" d="M314.62,24.45H43.44c-15.72,0-28.51,12.79-28.51,28.51s12.79,28.51,28.51,28.51h271.18c15.72,0,28.5-12.79,28.5-28.51s-12.79-28.51-28.5-28.51Z"/>
<path class="cls-53" d="M314.62,25.13H43.44c-15.34,0-27.83,12.48-27.83,27.83s12.49,27.83,27.83,27.83h271.18c15.34,0,27.82-12.49,27.82-27.83s-12.48-27.83-27.82-27.83Z"/>
<path class="cls-50" d="M314.62,25.81H43.44c-14.97,0-27.15,12.18-27.15,27.15s12.18,27.15,27.15,27.15h271.18c14.97,0,27.15-12.18,27.15-27.15s-12.18-27.15-27.15-27.15Z"/>
<path class="cls-68" d="M314.62,26.48H43.44c-14.59,0-26.47,11.88-26.47,26.48s11.88,26.47,26.47,26.47h271.18c14.59,0,26.47-11.88,26.47-26.47s-11.87-26.48-26.47-26.48Z"/>
<path class="cls-49" d="M314.62,27.16H43.44c-14.22,0-25.8,11.57-25.8,25.8s11.58,25.8,25.8,25.8h271.18c14.22,0,25.79-11.58,25.79-25.8s-11.57-25.8-25.79-25.8Z"/>
<path class="cls-83" d="M314.62,27.84H43.44c-13.84,0-25.12,11.27-25.12,25.12s11.27,25.12,25.12,25.12h271.18c13.85,0,25.11-11.27,25.11-25.12s-11.26-25.12-25.11-25.12Z"/>
<path class="cls-70" d="M314.62,28.52H43.44c-13.47,0-24.44,10.97-24.44,24.44s10.97,24.44,24.44,24.44h271.18c13.47,0,24.43-10.97,24.43-24.44s-10.96-24.44-24.43-24.44Z"/>
<path class="cls-87" d="M314.62,29.2H43.44c-13.1,0-23.76,10.66-23.76,23.76s10.67,23.76,23.76,23.76h271.18c13.1,0,23.75-10.66,23.75-23.76s-10.65-23.76-23.75-23.76Z"/>
<path class="cls-78" d="M314.62,29.88H43.44c-12.72,0-23.08,10.36-23.08,23.08s10.36,23.08,23.08,23.08h271.18c12.72,0,23.07-10.36,23.07-23.08s-10.35-23.08-23.07-23.08Z"/>
<path class="cls-69" d="M314.62,30.56H43.44c-12.35,0-22.41,10.05-22.41,22.4s10.06,22.41,22.41,22.41h271.18c12.35,0,22.39-10.06,22.39-22.41s-10.05-22.4-22.39-22.4Z"/>
<path class="cls-81" d="M314.62,31.23H43.44c-11.97,0-21.73,9.75-21.73,21.72s9.75,21.73,21.73,21.73h271.18c11.97,0,21.72-9.75,21.72-21.73s-9.74-21.72-21.72-21.72Z"/>
</g>
<g class="cls-48">
<path d="M314.62,20.38H43.44c-17.96,0-32.58,14.61-32.58,32.58s14.61,32.58,32.58,32.58h271.18c17.96,0,32.57-14.61,32.57-32.58s-14.61-32.58-32.57-32.58Z"/>
<path class="cls-85" d="M314.62,21.06H43.44c-17.59,0-31.9,14.31-31.9,31.91s14.31,31.9,31.9,31.9h271.18c17.59,0,31.9-14.31,31.9-31.9s-14.31-31.91-31.9-31.91Z"/>
<path class="cls-67" d="M314.62,21.74H43.44c-17.21,0-31.22,14-31.22,31.23s14.01,31.22,31.22,31.22h271.18c17.21,0,31.22-14.01,31.22-31.22s-14-31.23-31.22-31.23Z"/>
<path class="cls-60" d="M314.62,22.41H43.44c-16.84,0-30.54,13.7-30.54,30.55s13.7,30.54,30.54,30.54h271.18c16.84,0,30.54-13.7,30.54-30.54s-13.7-30.55-30.54-30.55h0Z"/>
<path class="cls-63" d="M314.62,23.09H43.44c-16.46,0-29.86,13.4-29.86,29.87s13.4,29.86,29.86,29.86h271.18c16.47,0,29.86-13.4,29.86-29.86s-13.39-29.87-29.86-29.87Z"/>
<path class="cls-54" d="M314.62,23.77H43.44c-16.09,0-29.19,13.09-29.19,29.19s13.1,29.19,29.19,29.19h271.18c16.09,0,29.18-13.09,29.18-29.19s-13.09-29.19-29.18-29.19Z"/>
<path class="cls-58" d="M314.62,24.45H43.44c-15.72,0-28.51,12.79-28.51,28.51s12.79,28.51,28.51,28.51h271.18c15.72,0,28.5-12.79,28.5-28.51s-12.79-28.51-28.5-28.51Z"/>
<path class="cls-86" d="M314.62,25.13H43.44c-15.34,0-27.83,12.48-27.83,27.83s12.49,27.83,27.83,27.83h271.18c15.34,0,27.82-12.49,27.82-27.83s-12.48-27.83-27.82-27.83Z"/>
<path class="cls-82" d="M314.62,25.81H43.44c-14.97,0-27.15,12.18-27.15,27.15s12.18,27.15,27.15,27.15h271.18c14.97,0,27.15-12.18,27.15-27.15s-12.18-27.15-27.15-27.15Z"/>
<path class="cls-56" d="M314.62,26.48H43.44c-14.59,0-26.47,11.88-26.47,26.48s11.88,26.47,26.47,26.47h271.18c14.59,0,26.47-11.88,26.47-26.47s-11.87-26.48-26.47-26.48Z"/>
<path class="cls-55" d="M314.62,27.16H43.44c-14.22,0-25.8,11.57-25.8,25.8s11.58,25.8,25.8,25.8h271.18c14.22,0,25.79-11.58,25.79-25.8s-11.57-25.8-25.79-25.8Z"/>
<path class="cls-88" d="M314.62,27.84H43.44c-13.84,0-25.12,11.27-25.12,25.12s11.27,25.12,25.12,25.12h271.18c13.85,0,25.11-11.27,25.11-25.12s-11.26-25.12-25.11-25.12Z"/>
<path class="cls-65" d="M314.62,28.52H43.44c-13.47,0-24.44,10.97-24.44,24.44s10.97,24.44,24.44,24.44h271.18c13.47,0,24.43-10.97,24.43-24.44s-10.96-24.44-24.43-24.44Z"/>
<path class="cls-80" d="M314.62,29.2H43.44c-13.1,0-23.76,10.66-23.76,23.76s10.67,23.76,23.76,23.76h271.18c13.1,0,23.75-10.66,23.75-23.76s-10.65-23.76-23.75-23.76Z"/>
<path class="cls-74" d="M314.62,29.88H43.44c-12.72,0-23.08,10.36-23.08,23.08s10.36,23.08,23.08,23.08h271.18c12.72,0,23.07-10.36,23.07-23.08s-10.35-23.08-23.07-23.08Z"/>
<path class="cls-72" d="M314.62,30.56H43.44c-12.35,0-22.41,10.05-22.41,22.4s10.06,22.41,22.41,22.41h271.18c12.35,0,22.39-10.06,22.39-22.41s-10.05-22.4-22.39-22.4Z"/>
<path class="cls-57" d="M314.62,31.23H43.44c-11.97,0-21.73,9.75-21.73,21.72s9.75,21.73,21.73,21.73h271.18c11.97,0,21.72-9.75,21.72-21.73s-9.74-21.72-21.72-21.72Z"/>
</g>
</g>
<g>
<path class="cls-34" d="M84.69,14.97c0,7.48-6.07,13.55-13.56,13.55s-13.56-6.07-13.56-13.55,6.07-13.56,13.56-13.56,13.56,6.07,13.56,13.56Z"/>
<path class="cls-24" d="M84.69,14.97c0,7.49-6.07,13.55-13.56,13.55s-13.56-6.06-13.56-13.55,6.07-13.56,13.56-13.56,13.56,6.07,13.56,13.56Z"/>
</g>
<g>
<path class="cls-47" d="M102.4,14.97c0,5.35-4.34,9.69-9.69,9.69s-9.69-4.33-9.69-9.69,4.34-9.69,9.69-9.69,9.69,4.34,9.69,9.69Z"/>
<path class="cls-30" d="M102.4,14.97c0,5.35-4.34,9.69-9.69,9.69s-9.69-4.33-9.69-9.69,4.34-9.69,9.69-9.69,9.69,4.33,9.69,9.69Z"/>
</g>
<g>
<path class="cls-20" d="M129.26,14.96c0,8.27-6.7,14.96-14.97,14.96s-14.96-6.69-14.96-14.96S106.03,0,114.29,0s14.97,6.7,14.97,14.96Z"/>
<path class="cls-31" d="M129.26,14.96c0,8.27-6.7,14.96-14.97,14.96s-14.97-6.69-14.97-14.96S106.02,0,114.29,0s14.97,6.69,14.97,14.96Z"/>
</g>
<g>
<path class="cls-3" d="M147.13,14.97c0,6.22-5.04,11.25-11.25,11.25s-11.25-5.04-11.25-11.25,5.04-11.26,11.25-11.26,11.25,5.04,11.25,11.26Z"/>
<path class="cls-5" d="M147.13,14.97c0,6.22-5.04,11.25-11.25,11.25s-11.26-5.04-11.26-11.25,5.04-11.26,11.26-11.26,11.25,5.04,11.25,11.26Z"/>
</g>
<g>
<path class="cls-43" d="M172.18,14.97c0,8.13-6.59,14.73-14.73,14.73s-14.73-6.59-14.73-14.73S149.31.24,157.45.24s14.73,6.6,14.73,14.73Z"/>
<path class="cls-26" d="M172.18,14.97c0,8.13-6.59,14.72-14.73,14.72s-14.73-6.59-14.73-14.72S149.32.24,157.45.24s14.73,6.59,14.73,14.73Z"/>
</g>
<g>
<path class="cls-27" d="M188.83,14.97c0,5.41-4.39,9.79-9.79,9.79s-9.8-4.38-9.8-9.79,4.38-9.8,9.8-9.8,9.79,4.39,9.79,9.8Z"/>
<path class="cls-6" d="M188.83,14.97c0,5.41-4.39,9.79-9.79,9.79s-9.8-4.38-9.8-9.79,4.38-9.8,9.8-9.8,9.79,4.38,9.79,9.8Z"/>
</g>
<g>
<path class="cls-35" d="M209.61,14.97c0,4.97-4.03,9-9,9s-9-4.03-9-9,4.03-9,9-9,9,4.03,9,9Z"/>
<path class="cls-17" d="M209.61,14.97c0,4.97-4.03,8.99-9,8.99s-9-4.02-9-8.99,4.03-9,9-9,9,4.02,9,9Z"/>
</g>
<g>
<path class="cls-18" d="M236.83,14.97c0,8.09-6.56,14.64-14.64,14.64s-14.64-6.55-14.64-14.64S214.1.33,222.19.33s14.64,6.55,14.64,14.64Z"/>
<path class="cls-4" d="M236.83,14.97c0,8.09-6.56,14.64-14.64,14.64s-14.65-6.55-14.65-14.64S214.1.33,222.19.33s14.64,6.55,14.64,14.64Z"/>
</g>
<g>
<path class="cls-8" d="M254.37,14.96c0,5.85-4.74,10.6-10.6,10.6s-10.6-4.75-10.6-10.6,4.75-10.6,10.6-10.6,10.6,4.75,10.6,10.6Z"/>
<path class="cls-25" d="M254.37,14.96c0,5.85-4.74,10.6-10.6,10.6s-10.61-4.74-10.61-10.6,4.75-10.6,10.61-10.6,10.6,4.74,10.6,10.6Z"/>
</g>
<g>
<path class="cls-19" d="M276.09,14.97c0,5.93-4.8,10.73-10.74,10.73s-10.74-4.81-10.74-10.73,4.81-10.74,10.74-10.74,10.74,4.81,10.74,10.74Z"/>
<path class="cls-37" d="M276.09,14.97c0,5.93-4.8,10.73-10.74,10.73s-10.74-4.8-10.74-10.73,4.81-10.74,10.74-10.74,10.74,4.8,10.74,10.74Z"/>
</g>
<g>
<path class="cls-42" d="M299.04,14.96c0,6.68-5.42,12.1-12.1,12.1s-12.11-5.42-12.11-12.1,5.42-12.11,12.11-12.11,12.1,5.42,12.1,12.11Z"/>
<path class="cls-13" d="M299.04,14.96c0,6.69-5.42,12.1-12.1,12.1s-12.11-5.41-12.11-12.1,5.42-12.11,12.11-12.11,12.1,5.42,12.1,12.11Z"/>
</g>
<g>
<path class="cls-7" d="M316.93,14.97c0,4.65-3.77,8.43-8.43,8.43s-8.43-3.78-8.43-8.43,3.77-8.43,8.43-8.43,8.43,3.77,8.43,8.43Z"/>
<path class="cls-39" d="M316.93,14.97c0,4.66-3.77,8.43-8.43,8.43s-8.43-3.77-8.43-8.43,3.78-8.43,8.43-8.43,8.43,3.77,8.43,8.43Z"/>
</g>
<g>
<path class="cls-45" d="M57.99,14.96c0,4.66-3.77,8.43-8.43,8.43s-8.43-3.77-8.43-8.43,3.78-8.43,8.43-8.43,8.43,3.78,8.43,8.43Z"/>
<path class="cls-44" d="M57.99,14.96c0,4.66-3.77,8.43-8.43,8.43s-8.43-3.77-8.43-8.43,3.78-8.43,8.43-8.43,8.43,3.77,8.43,8.43Z"/>
</g>
<g>
<path class="cls-11" d="M351.9,32.62c0,2.96-2.4,5.36-5.36,5.36s-5.36-2.4-5.36-5.36,2.4-5.36,5.36-5.36,5.36,2.4,5.36,5.36Z"/>
<path class="cls-38" d="M351.9,32.62c0,2.96-2.4,5.36-5.36,5.36s-5.36-2.4-5.36-5.36,2.4-5.36,5.36-5.36,5.36,2.4,5.36,5.36Z"/>
</g>
<g>
<path class="cls-2" d="M354.92,52.62c0,1.71-1.39,3.1-3.1,3.1s-3.1-1.39-3.1-3.1,1.39-3.1,3.1-3.1,3.1,1.39,3.1,3.1Z"/>
<path class="cls-36" d="M354.92,52.62c0,1.71-1.39,3.1-3.1,3.1s-3.1-1.39-3.1-3.1,1.39-3.1,3.1-3.1,3.1,1.39,3.1,3.1Z"/>
</g>
<g>
<path class="cls-40" d="M350.33,75.09c0,2.47-2,4.47-4.47,4.47s-4.47-2-4.47-4.47,2-4.47,4.47-4.47,4.47,2,4.47,4.47Z"/>
<path class="cls-15" d="M350.33,75.09c0,2.47-2,4.47-4.47,4.47s-4.47-2-4.47-4.47,2-4.47,4.47-4.47,4.47,2,4.47,4.47Z"/>
</g>
<g>
<path class="cls-23" d="M335.52,18.07c0,2.47-2,4.47-4.47,4.47s-4.47-2-4.47-4.47,2-4.47,4.47-4.47,4.47,2,4.47,4.47Z"/>
<path class="cls-46" d="M335.52,18.07c0,2.47-2,4.47-4.47,4.47s-4.47-2-4.47-4.47,2-4.47,4.47-4.47,4.47,2,4.47,4.47Z"/>
</g>
<g>
<path class="cls-33" d="M333.31,88.67c0,2.34-1.9,4.24-4.24,4.24s-4.24-1.9-4.24-4.24,1.9-4.24,4.24-4.24,4.24,1.9,4.24,4.24Z"/>
<path class="cls-14" d="M333.31,88.68c0,2.34-1.9,4.23-4.24,4.23s-4.24-1.89-4.24-4.23,1.9-4.24,4.24-4.24,4.24,1.9,4.24,4.24Z"/>
</g>
<g>
<path class="cls-16" d="M7.03,32.62c0,2.61,2.12,4.73,4.73,4.73s4.73-2.12,4.73-4.73-2.12-4.73-4.73-4.73-4.73,2.12-4.73,4.73Z"/>
<path class="cls-29" d="M7.03,32.62c0,2.61,2.12,4.73,4.73,4.73s4.73-2.12,4.73-4.73-2.12-4.73-4.73-4.73-4.73,2.12-4.73,4.73Z"/>
</g>
<g>
<path class="cls-32" d="M3.47,52.62c0,1.71,1.39,3.1,3.1,3.1s3.1-1.39,3.1-3.1-1.39-3.1-3.1-3.1-3.1,1.39-3.1,3.1Z"/>
<path class="cls-21" d="M3.47,52.62c0,1.71,1.39,3.1,3.1,3.1s3.1-1.39,3.1-3.1-1.39-3.1-3.1-3.1-3.1,1.39-3.1,3.1Z"/>
</g>
<g>
<path class="cls-41" d="M8.06,75.09c0,2.47,2,4.47,4.47,4.47s4.47-2,4.47-4.47-2-4.47-4.47-4.47-4.47,2-4.47,4.47Z"/>
<path class="cls-10" d="M8.06,75.09c0,2.47,2,4.47,4.47,4.47s4.47-2,4.47-4.47-2-4.47-4.47-4.47-4.47,2-4.47,4.47Z"/>
</g>
<g>
<path class="cls-9" d="M22.87,18.07c0,2.47,2,4.47,4.47,4.47s4.47-2,4.47-4.47-2-4.47-4.47-4.47-4.47,2-4.47,4.47Z"/>
<path class="cls-1" d="M22.87,18.07c0,2.47,2,4.47,4.47,4.47s4.47-2,4.47-4.47-2-4.47-4.47-4.47-4.47,2-4.47,4.47Z"/>
</g>
<g>
<path class="cls-12" d="M25.08,88.67c0,2.34,1.9,4.24,4.24,4.24s4.24-1.9,4.24-4.24-1.9-4.24-4.24-4.24-4.24,1.9-4.24,4.24Z"/>
<path class="cls-28" d="M25.08,88.68c0,2.34,1.9,4.23,4.24,4.23s4.24-1.89,4.24-4.23-1.9-4.24-4.24-4.24-4.24,1.9-4.24,4.24Z"/>
</g>
</g>
</g>
</g>
</g>
</svg>
  <div className="wheel-jackpot-amount-text">${formattedMegaJackpot}</div>
</div>
<div className="wheel-jackpot-current">
  <div className="wheel-jackpot-current-text">MEGA JACKPOT</div>
</div>
<div className="wheel-jackpot-amount-title ">
<svg id="wheel-jackpot-svg-mini" className="jackpot-svg-bottom" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 358.06 96.4" width="100%" height="100%">
<defs>
<style>{`
#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-1 {
fill: url(#wheel-radial-gradient-44);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-1, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-2, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-3, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-4, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-5, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-6, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-7, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-8, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-9, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-10, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-11, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-12, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-13, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-14, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-15, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-16, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-17, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-18, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-19, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-20, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-21, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-22, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-23, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-24, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-25, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-26, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-27, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-28, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-29, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-30, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-31, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-32, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-33, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-34, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-35, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-36, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-37, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-38, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-39, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-40, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-41, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-42, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-43, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-44, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-45, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-46, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-47 {
isolation: isolate;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-1, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-4, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-5, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-6, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-10, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-13, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-14, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-15, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-17, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-21, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-24, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-25, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-26, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-28, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-29, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-30, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-31, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-48, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-36, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-37, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-38, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-39, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-44, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-46 {
mix-blend-mode: screen;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-49 {
fill: url(#wheel-linear-gradient-15);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-50 {
fill: url(#wheel-linear-gradient-13);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-2 {
fill: url(#wheel-radial-gradient-29);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-2, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-3, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-7, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-8, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-9, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-11, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-12, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-16, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-18, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-19, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-20, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-23, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-27, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-32, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-33, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-34, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-35, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-40, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-41, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-42, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-43, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-45, #wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-47 {
mix-blend-mode: color-dodge;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-3 {
fill: url(#wheel-radial-gradient-7);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-4 {
fill: url(#wheel-radial-gradient-16);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-5 {
fill: url(#wheel-radial-gradient-8);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-6 {
fill: url(#wheel-radial-gradient-12);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-7 {
fill: url(#wheel-radial-gradient-23);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-8 {
fill: url(#wheel-radial-gradient-17);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-51 {
fill: url(#wheel-linear-gradient-2);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-52 {
fill: url(#wheel-linear-gradient-10);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-53 {
fill: url(#wheel-linear-gradient-12);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-54 {
fill: #505050;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-9 {
fill: url(#wheel-radial-gradient-43);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-55 {
fill: #9f9f9f;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-10 {
fill: url(#wheel-radial-gradient-42);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-56 {
fill: #8f8f8f;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-11 {
fill: url(#wheel-radial-gradient-27);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-57 {
fill: #fff;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-12 {
fill: url(#wheel-radial-gradient-45);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-13 {
fill: url(#wheel-radial-gradient-22);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-14 {
fill: url(#wheel-radial-gradient-36);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-15 {
fill: url(#wheel-radial-gradient-32);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-16 {
fill: url(#wheel-radial-gradient-37);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-58 {
fill: #606060;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-59 {
fill: url(#wheel-linear-gradient-4);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-60 {
fill: #303030;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-17 {
fill: url(#wheel-radial-gradient-14);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-18 {
fill: url(#wheel-radial-gradient-15);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-19 {
fill: url(#wheel-radial-gradient-19);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-20 {
fill: url(#wheel-radial-gradient-5);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-61 {
fill: url(#wheel-linear-gradient-3);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-62 {
fill: url(#wheel-linear-gradient-5);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-63 {
fill: #404040;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-21 {
fill: url(#wheel-radial-gradient-40);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-64 {
fill: url(#wheel-linear-gradient-22);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-23 {
fill: url(#wheel-radial-gradient-33);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-24 {
fill: url(#wheel-radial-gradient-2);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-65 {
fill: #bfbfbf;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-25 {
fill: url(#wheel-radial-gradient-18);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-66 {
fill: url(#wheel-linear-gradient-8);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-67 {
fill: #202020;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-26 {
fill: url(#wheel-radial-gradient-10);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-27 {
fill: url(#wheel-radial-gradient-11);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-28 {
fill: url(#wheel-radial-gradient-46);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-29 {
fill: url(#wheel-radial-gradient-38);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-30 {
fill: url(#wheel-radial-gradient-4);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-68 {
fill: url(#wheel-linear-gradient-14);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-31 {
fill: url(#wheel-radial-gradient-6);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-69 {
fill: url(#wheel-linear-gradient-20);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-32 {
fill: url(#wheel-radial-gradient-39);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-70 {
fill: url(#wheel-linear-gradient-17);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-33 {
fill: url(#wheel-radial-gradient-35);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-71 {
fill: url(#wheel-linear-gradient-7);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-72 {
fill: #efefef;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-73 {
fill: url(#wheel-linear-gradient-9);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-74 {
fill: #dfdfdf;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-34 {
fill: url(#wheel-radial-gradient);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-75,#wheel-jackpot-svg-bottom#wheel-jackpot-svg-mini .cls-76 {
mix-blend-mode: multiply;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-35 {
fill: url(#wheel-radial-gradient-13);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-77 {
fill: url(#wheel-linear-gradient-11);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-36 {
fill: url(#wheel-radial-gradient-30);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-37 {
fill: url(#wheel-radial-gradient-20);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-78 {
fill: url(#wheel-linear-gradient-19);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-38 {
fill: url(#wheel-radial-gradient-28);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-79 {
fill: url(#wheel-linear-gradient-6);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-39 {
fill: url(#wheel-radial-gradient-24);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-80 {
fill: #cfcfcf;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-40 {
fill: url(#wheel-radial-gradient-31);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-81 {
fill: url(#wheel-linear-gradient-21);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-41 {
fill: url(#wheel-radial-gradient-41);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-42 {
fill: url(#wheel-radial-gradient-21);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-43 {
fill: url(#wheel-radial-gradient-9);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-82 {
fill: gray;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-44 {
fill: url(#wheel-radial-gradient-26);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-83 {
fill: url(#wheel-linear-gradient-16);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-84 {
fill: url(#wheel-linear-gradient);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-45 {
fill: url(#wheel-radial-gradient-25);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-46 {
fill: url(#wheel-radial-gradient-34);
animation: blink 1s ease-in-out infinite;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-85 {
fill: #101010;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-86 {
fill: #707070;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-87 {
fill: url(#wheel-linear-gradient-18);
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-88 {
fill: #afafaf;
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-47 {
fill: url(#wheel-radial-gradient-3);
animation: blink 1s ease-in-out infinite;
}

@keyframes blink {
0%, 100% {
opacity: 1;
}
50% {
opacity: 0.3;
}
}

#wheel-jackpot-svg-mini#wheel-jackpot-svg-mini .cls-76 {
opacity: .5;
}
`}</style>
<linearGradient id="wheel-linear-gradient" x1="179.03" y1="266.49" x2="179.03" y2="179.61" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#ffc0c0"/>
<stop offset=".5" stop-color="red"/>
<stop offset="1" stop-color="maroon"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-2" x1="179.04" y1="265.13" x2="179.04" y2="180.97" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="red"/>
<stop offset="1" stop-color="maroon"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-3" x1="179.02" y1="189.1" x2="179.02" y2="256.98" href="#wheel-linear-gradient-2"/>
<linearGradient id="wheel-linear-gradient-4" x1="179.02" y1="190.47" x2="179.02" y2="255.63" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#b37920"/>
<stop offset=".19" stop-color="#ffda80"/>
<stop offset=".27" stop-color="#e6ba60"/>
<stop offset=".36" stop-color="#ce9a41"/>
<stop offset=".44" stop-color="#bf872d"/>
<stop offset=".5" stop-color="#ba8027"/>
<stop offset=".57" stop-color="#d0a758"/>
<stop offset=".65" stop-color="#e4cb85"/>
<stop offset=".72" stop-color="#f2e4a5"/>
<stop offset=".77" stop-color="#fbf4b8"/>
<stop offset=".81" stop-color="#fffac0"/>
<stop offset="1" stop-color="#fffac0"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-5" x1="179.02" y1="190.47" x2="179.02" y2="255.63" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#c78730"/>
<stop offset="1" stop-color="#682800"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-6" x1="179.03" y1="191.14" x2="179.03" y2="254.95" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#cb8f3d"/>
<stop offset="1" stop-color="#713510"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-7" x1="179.03" y1="191.82" x2="179.03" y2="254.27" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#ce964a"/>
<stop offset="1" stop-color="#7b4320"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-8" x1="179.03" y1="192.51" x2="179.03" y2="253.6" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#d29e57"/>
<stop offset="1" stop-color="#845030"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-9" x1="179.03" y1="193.19" x2="179.03" y2="252.92" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#d5a564"/>
<stop offset="1" stop-color="#8e5e40"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-10" x1="179.02" y1="193.86" x2="179.02" y2="252.24" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#d9ad71"/>
<stop offset="1" stop-color="#976b50"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-11" x1="179.02" y1="194.54" x2="179.02" y2="251.56" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#dcb47e"/>
<stop offset="1" stop-color="#a17960"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-12" x1="179.03" y1="195.22" x2="179.03" y2="250.88" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#e0bc8b"/>
<stop offset="1" stop-color="#aa8670"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-13" x1="179.03" y1="195.9" x2="179.03" y2="250.2" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#e3c398"/>
<stop offset="1" stop-color="#b39380"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-14" x1="179.03" y1="196.58" x2="179.03" y2="249.53" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#e7cba4"/>
<stop offset="1" stop-color="#bda18f"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-15" x1="179.03" y1="197.25" x2="179.03" y2="248.85" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#ead2b1"/>
<stop offset="1" stop-color="#c6ae9f"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-16" x1="179.02" y1="197.93" x2="179.02" y2="248.17" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#eedabe"/>
<stop offset="1" stop-color="#d0bcaf"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-17" x1="179.02" y1="198.61" x2="179.02" y2="247.49" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#f1e1cb"/>
<stop offset="1" stop-color="#d9c9bf"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-18" x1="179.02" y1="199.29" x2="179.02" y2="246.81" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#f5e9d8"/>
<stop offset="1" stop-color="#e3d7cf"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-19" x1="179.03" y1="199.97" x2="179.03" y2="246.13" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#f8f0e5"/>
<stop offset="1" stop-color="#ece4df"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-20" x1="179.02" y1="200.64" x2="179.02" y2="245.45" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#fcf8f2"/>
<stop offset="1" stop-color="#f6f2ef"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-21" x1="179.02" y1="201.33" x2="179.02" y2="244.78" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#fff"/>
<stop offset="1" stop-color="#fff"/>
</linearGradient>
<linearGradient id="wheel-linear-gradient-22" x1="180.13" y1="258.1" x2="180.13" y2="189.67" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset="0" stop-color="#404040"/>
<stop offset="1" stop-color="#101010"/>
</linearGradient>
<radialGradient id="wheel-radial-gradient" cx="71.13" cy="261.04" fx="71.13" fy="261.04" r="13.56" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset=".13" stop-color="#fff"/>
<stop offset=".19" stop-color="#e6e6e6"/>
<stop offset=".36" stop-color="#a1a1a1"/>
<stop offset=".53" stop-color="#676767"/>
<stop offset=".68" stop-color="#3a3a3a"/>
<stop offset=".81" stop-color="#1a1a1a"/>
<stop offset=".92" stop-color="#070707"/>
<stop offset="1" stop-color="#000"/>
</radialGradient>
<radialGradient id="wheel-radial-gradient-2" cx="71.13" cy="261.04" fx="71.13" fy="261.04" r="13.56" gradientTransform="translate(0 276.01) scale(1 -1)" gradientUnits="userSpaceOnUse">
<stop offset=".13" stop-color="#fff"/>
<stop offset=".18" stop-color="#dadada"/>
<stop offset=".27" stop-color="#a7a7a7"/>
<stop offset=".36" stop-color="#7a7a7a"/>
<stop offset=".45" stop-color="#545454"/>
<stop offset=".54" stop-color="#353535"/>
<stop offset=".64" stop-color="#1e1e1e"/>
<stop offset=".75" stop-color="#0d0d0d"/>
<stop offset=".86" stop-color="#030303"/>
<stop offset="1" stop-color="#000"/>
</radialGradient>
<radialGradient id="wheel-radial-gradient-3" cx="92.71" cy="261.04" fx="92.71" fy="261.04" r="9.69" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-4" cx="92.71" cy="261.04" fx="92.71" fy="261.04" r="9.69" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-5" cx="114.29" cy="261.05" fx="114.29" fy="261.05" r="14.96" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-6" cx="114.29" cy="261.05" fx="114.29" fy="261.05" r="14.97" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-7" cx="135.88" cy="261.04" fx="135.88" fy="261.04" r="11.25" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-8" cx="135.88" cy="261.04" fx="135.88" fy="261.04" r="11.26" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-9" cx="157.45" cy="261.04" fx="157.45" fy="261.04" r="14.73" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-10" cx="157.45" fx="157.45" r="14.73" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-11" cx="179.04" cy="261.04" fx="179.04" fy="261.04" r="9.8" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-12" cx="179.04" cy="261.04" fx="179.04" fy="261.04" r="9.8" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-13" cx="200.61" cy="261.04" fx="200.61" fy="261.04" r="9" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-14" cx="200.61" cy="261.04" fx="200.61" fy="261.04" r="9" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-15" cx="222.19" cy="261.04" fx="222.19" fy="261.04" r="14.64" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-16" cx="222.19" cy="261.04" fx="222.19" fy="261.04" r="14.64" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-17" cx="243.77" cy="261.05" fx="243.77" fy="261.05" r="10.6" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-18" cx="243.76" cy="261.05" fx="243.76" fy="261.05" r="10.6" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-19" cx="265.35" cy="261.04" fx="265.35" fy="261.04" r="10.74" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-20" cx="265.35" cy="261.04" fx="265.35" fy="261.04" r="10.74" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-21" cx="286.94" cy="261.05" fx="286.94" fy="261.05" r="12.1" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-22" cx="286.94" cy="261.05" fx="286.94" fy="261.05" r="12.1" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-23" cx="308.5" cy="261.04" fx="308.5" fy="261.04" r="8.43" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-24" cx="308.5" cy="261.04" fx="308.5" fy="261.04" r="8.43" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-25" cx="49.56" cy="261.05" fx="49.56" fy="261.05" r="8.43" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-26" cx="49.56" cy="261.05" fx="49.56" fy="261.05" r="8.43" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-27" cx="346.54" cy="243.39" fx="346.54" fy="243.39" r="5.36" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-28" cx="346.54" cy="243.39" fx="346.54" fy="243.39" r="5.36" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-29" cx="351.82" cy="223.39" fx="351.82" fy="223.39" r="3.1" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-30" cx="351.81" cy="223.39" fx="351.81" fy="223.39" r="3.1" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-31" cx="345.86" cy="200.92" fx="345.86" fy="200.92" r="4.47" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-32" cx="345.86" cy="200.92" fx="345.86" fy="200.92" r="4.47" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-33" cx="331.05" cy="257.94" fx="331.05" fy="257.94" r="4.47" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-34" cx="331.05" cy="257.94" fx="331.05" fy="257.94" r="4.47" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-35" cx="329.07" cy="187.34" fx="329.07" fy="187.34" r="4.24" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-36" cx="329.07" cy="187.33" fx="329.07" fy="187.33" r="4.24" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-37" cx="-608.15" cy="243.39" fx="-608.15" fy="243.39" r="4.73" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-38" cx="-608.15" cy="243.39" fx="-608.15" fy="243.39" r="4.73" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-39" cx="-602.96" cy="223.39" fx="-602.96" fy="223.39" r="3.1" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-40" cx="-602.96" cy="223.39" fx="-602.96" fy="223.39" r="3.1" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-41" cx="-608.92" cy="200.92" fx="-608.92" fy="200.92" r="4.47" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-42" cx="-608.92" cy="200.92" fx="-608.92" fy="200.92" r="4.47" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-43" cx="-623.73" cy="257.94" fx="-623.73" fy="257.94" r="4.47" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-44" cx="-623.73" cy="257.94" fx="-623.73" fy="257.94" r="4.47" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient-2"/>
<radialGradient id="wheel-radial-gradient-45" cx="-625.7" cy="187.34" fx="-625.7" fy="187.34" r="4.24" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient"/>
<radialGradient id="wheel-radial-gradient-46" cx="-625.7" cy="187.33" fx="-625.7" fy="187.33" r="4.24" gradientTransform="translate(-596.39 276.01) rotate(-180)" href="#wheel-radial-gradient-2"/>
</defs>
<g class="cls-22">
<g id="Layer_2" data-name="Layer 2">
<g id="Layer_1-2" data-name="Layer 1">
<g>
<path class="cls-84" d="M358.06,52.96c0,23.99-19.45,43.44-43.44,43.44H43.44C19.45,96.4,0,76.95,0,52.96S19.45,9.52,43.44,9.52h271.18c23.99,0,43.44,19.45,43.44,43.44Z"/>
<path class="cls-51" d="M314.62,95.04H43.44C20.23,95.04,1.36,76.16,1.36,52.96S20.23,10.88,43.44,10.88h271.19c23.21,0,42.08,18.88,42.08,42.08s-18.87,42.08-42.08,42.08h-.01Z"/>
<path class="cls-61" d="M314.62,86.91H43.44c-18.72,0-33.94-15.23-33.94-33.95S24.72,19.03,43.44,19.03h271.18c18.71,0,33.93,15.22,33.93,33.93s-15.22,33.95-33.93,33.95h0Z"/>
<path class="cls-59" d="M314.62,20.38H43.44c-17.96,0-32.58,14.61-32.58,32.58s14.61,32.58,32.58,32.58h271.18c17.96,0,32.57-14.61,32.57-32.58s-14.61-32.58-32.57-32.58Z"/>
<g class="cls-75">
<g>
<path class="cls-62" d="M314.62,20.38H43.44c-17.96,0-32.58,14.61-32.58,32.58s14.61,32.58,32.58,32.58h271.18c17.96,0,32.57-14.61,32.57-32.58s-14.61-32.58-32.57-32.58Z"/>
<path class="cls-79" d="M314.62,21.06H43.44c-17.59,0-31.9,14.31-31.9,31.91s14.31,31.9,31.9,31.9h271.18c17.59,0,31.9-14.31,31.9-31.9s-14.31-31.91-31.9-31.91Z"/>
<path class="cls-71" d="M314.62,21.74H43.44c-17.21,0-31.22,14-31.22,31.23s14.01,31.22,31.22,31.22h271.18c17.21,0,31.22-14.01,31.22-31.22s-14-31.23-31.22-31.23Z"/>
<path class="cls-66" d="M314.62,22.41H43.44c-16.84,0-30.54,13.7-30.54,30.55s13.7,30.54,30.54,30.54h271.18c16.84,0,30.54-13.7,30.54-30.54s-13.7-30.55-30.54-30.55h0Z"/>
<path class="cls-73" d="M314.62,23.09H43.44c-16.46,0-29.86,13.4-29.86,29.87s13.4,29.86,29.86,29.86h271.18c16.47,0,29.86-13.4,29.86-29.86s-13.39-29.87-29.86-29.87Z"/>
<path class="cls-52" d="M314.62,23.77H43.44c-16.09,0-29.19,13.09-29.19,29.19s13.1,29.19,29.19,29.19h271.18c16.09,0,29.18-13.09,29.18-29.19s-13.09-29.19-29.18-29.19Z"/>
<path class="cls-77" d="M314.62,24.45H43.44c-15.72,0-28.51,12.79-28.51,28.51s12.79,28.51,28.51,28.51h271.18c15.72,0,28.5-12.79,28.5-28.51s-12.79-28.51-28.5-28.51Z"/>
<path class="cls-53" d="M314.62,25.13H43.44c-15.34,0-27.83,12.48-27.83,27.83s12.49,27.83,27.83,27.83h271.18c15.34,0,27.82-12.49,27.82-27.83s-12.48-27.83-27.82-27.83Z"/>
<path class="cls-50" d="M314.62,25.81H43.44c-14.97,0-27.15,12.18-27.15,27.15s12.18,27.15,27.15,27.15h271.18c14.97,0,27.15-12.18,27.15-27.15s-12.18-27.15-27.15-27.15Z"/>
<path class="cls-68" d="M314.62,26.48H43.44c-14.59,0-26.47,11.88-26.47,26.48s11.88,26.47,26.47,26.47h271.18c14.59,0,26.47-11.88,26.47-26.47s-11.87-26.48-26.47-26.48Z"/>
<path class="cls-49" d="M314.62,27.16H43.44c-14.22,0-25.8,11.57-25.8,25.8s11.58,25.8,25.8,25.8h271.18c14.22,0,25.79-11.58,25.79-25.8s-11.57-25.8-25.79-25.8Z"/>
<path class="cls-83" d="M314.62,27.84H43.44c-13.84,0-25.12,11.27-25.12,25.12s11.27,25.12,25.12,25.12h271.18c13.85,0,25.11-11.27,25.11-25.12s-11.26-25.12-25.11-25.12Z"/>
<path class="cls-70" d="M314.62,28.52H43.44c-13.47,0-24.44,10.97-24.44,24.44s10.97,24.44,24.44,24.44h271.18c13.47,0,24.43-10.97,24.43-24.44s-10.96-24.44-24.43-24.44Z"/>
<path class="cls-87" d="M314.62,29.2H43.44c-13.1,0-23.76,10.66-23.76,23.76s10.67,23.76,23.76,23.76h271.18c13.1,0,23.75-10.66,23.75-23.76s-10.65-23.76-23.75-23.76Z"/>
<path class="cls-78" d="M314.62,29.88H43.44c-12.72,0-23.08,10.36-23.08,23.08s10.36,23.08,23.08,23.08h271.18c12.72,0,23.07-10.36,23.07-23.08s-10.35-23.08-23.07-23.08Z"/>
<path class="cls-69" d="M314.62,30.56H43.44c-12.35,0-22.41,10.05-22.41,22.4s10.06,22.41,22.41,22.41h271.18c12.35,0,22.39-10.06,22.39-22.41s-10.05-22.4-22.39-22.4Z"/>
<path class="cls-81" d="M314.62,31.23H43.44c-11.97,0-21.73,9.75-21.73,21.72s9.75,21.73,21.73,21.73h271.18c11.97,0,21.72-9.75,21.72-21.73s-9.74-21.72-21.72-21.72Z"/>
</g>
<g class="cls-48">
<path d="M314.62,20.38H43.44c-17.96,0-32.58,14.61-32.58,32.58s14.61,32.58,32.58,32.58h271.18c17.96,0,32.57-14.61,32.57-32.58s-14.61-32.58-32.57-32.58Z"/>
<path class="cls-85" d="M314.62,21.06H43.44c-17.59,0-31.9,14.31-31.9,31.91s14.31,31.9,31.9,31.9h271.18c17.59,0,31.9-14.31,31.9-31.9s-14.31-31.91-31.9-31.91Z"/>
<path class="cls-67" d="M314.62,21.74H43.44c-17.21,0-31.22,14-31.22,31.23s14.01,31.22,31.22,31.22h271.18c17.21,0,31.22-14.01,31.22-31.22s-14-31.23-31.22-31.23Z"/>
<path class="cls-60" d="M314.62,22.41H43.44c-16.84,0-30.54,13.7-30.54,30.55s13.7,30.54,30.54,30.54h271.18c16.84,0,30.54-13.7,30.54-30.54s-13.7-30.55-30.54-30.55h0Z"/>
<path class="cls-63" d="M314.62,23.09H43.44c-16.46,0-29.86,13.4-29.86,29.87s13.4,29.86,29.86,29.86h271.18c16.47,0,29.86-13.4,29.86-29.86s-13.39-29.87-29.86-29.87Z"/>
<path class="cls-54" d="M314.62,23.77H43.44c-16.09,0-29.19,13.09-29.19,29.19s13.1,29.19,29.19,29.19h271.18c16.09,0,29.18-13.09,29.18-29.19s-13.09-29.19-29.18-29.19Z"/>
<path class="cls-58" d="M314.62,24.45H43.44c-15.72,0-28.51,12.79-28.51,28.51s12.79,28.51,28.51,28.51h271.18c15.72,0,28.5-12.79,28.5-28.51s-12.79-28.51-28.5-28.51Z"/>
<path class="cls-86" d="M314.62,25.13H43.44c-15.34,0-27.83,12.48-27.83,27.83s12.49,27.83,27.83,27.83h271.18c15.34,0,27.82-12.49,27.82-27.83s-12.48-27.83-27.82-27.83Z"/>
<path class="cls-82" d="M314.62,25.81H43.44c-14.97,0-27.15,12.18-27.15,27.15s12.18,27.15,27.15,27.15h271.18c14.97,0,27.15-12.18,27.15-27.15s-12.18-27.15-27.15-27.15Z"/>
<path class="cls-56" d="M314.62,26.48H43.44c-14.59,0-26.47,11.88-26.47,26.48s11.88,26.47,26.47,26.47h271.18c14.59,0,26.47-11.88,26.47-26.47s-11.87-26.48-26.47-26.48Z"/>
<path class="cls-55" d="M314.62,27.16H43.44c-14.22,0-25.8,11.57-25.8,25.8s11.58,25.8,25.8,25.8h271.18c14.22,0,25.79-11.58,25.79-25.8s-11.57-25.8-25.79-25.8Z"/>
<path class="cls-88" d="M314.62,27.84H43.44c-13.84,0-25.12,11.27-25.12,25.12s11.27,25.12,25.12,25.12h271.18c13.85,0,25.11-11.27,25.11-25.12s-11.26-25.12-25.11-25.12Z"/>
<path class="cls-65" d="M314.62,28.52H43.44c-13.47,0-24.44,10.97-24.44,24.44s10.97,24.44,24.44,24.44h271.18c13.47,0,24.43-10.97,24.43-24.44s-10.96-24.44-24.43-24.44Z"/>
<path class="cls-80" d="M314.62,29.2H43.44c-13.1,0-23.76,10.66-23.76,23.76s10.67,23.76,23.76,23.76h271.18c13.1,0,23.75-10.66,23.75-23.76s-10.65-23.76-23.75-23.76Z"/>
<path class="cls-74" d="M314.62,29.88H43.44c-12.72,0-23.08,10.36-23.08,23.08s10.36,23.08,23.08,23.08h271.18c12.72,0,23.07-10.36,23.07-23.08s-10.35-23.08-23.07-23.08Z"/>
<path class="cls-72" d="M314.62,30.56H43.44c-12.35,0-22.41,10.05-22.41,22.4s10.06,22.41,22.41,22.41h271.18c12.35,0,22.39-10.06,22.39-22.41s-10.05-22.4-22.39-22.4Z"/>
<path class="cls-57" d="M314.62,31.23H43.44c-11.97,0-21.73,9.75-21.73,21.72s9.75,21.73,21.73,21.73h271.18c11.97,0,21.72-9.75,21.72-21.73s-9.74-21.72-21.72-21.72Z"/>
</g>
</g>
<g class="cls-76">
<g>
<path class="cls-62" d="M314.62,20.38H43.44c-17.96,0-32.58,14.61-32.58,32.58s14.61,32.58,32.58,32.58h271.18c17.96,0,32.57-14.61,32.57-32.58s-14.61-32.58-32.57-32.58Z"/>
<path class="cls-79" d="M314.62,21.06H43.44c-17.59,0-31.9,14.31-31.9,31.91s14.31,31.9,31.9,31.9h271.18c17.59,0,31.9-14.31,31.9-31.9s-14.31-31.91-31.9-31.91Z"/>
<path class="cls-71" d="M314.62,21.74H43.44c-17.21,0-31.22,14-31.22,31.23s14.01,31.22,31.22,31.22h271.18c17.21,0,31.22-14.01,31.22-31.22s-14-31.23-31.22-31.23Z"/>
<path class="cls-66" d="M314.62,22.41H43.44c-16.84,0-30.54,13.7-30.54,30.55s13.7,30.54,30.54,30.54h271.18c16.84,0,30.54-13.7,30.54-30.54s-13.7-30.55-30.54-30.55h0Z"/>
<path class="cls-73" d="M314.62,23.09H43.44c-16.46,0-29.86,13.4-29.86,29.87s13.4,29.86,29.86,29.86h271.18c16.47,0,29.86-13.4,29.86-29.86s-13.39-29.87-29.86-29.87Z"/>
<path class="cls-52" d="M314.62,23.77H43.44c-16.09,0-29.19,13.09-29.19,29.19s13.1,29.19,29.19,29.19h271.18c16.09,0,29.18-13.09,29.18-29.19s-13.09-29.19-29.18-29.19Z"/>
<path class="cls-77" d="M314.62,24.45H43.44c-15.72,0-28.51,12.79-28.51,28.51s12.79,28.51,28.51,28.51h271.18c15.72,0,28.5-12.79,28.5-28.51s-12.79-28.51-28.5-28.51Z"/>
<path class="cls-53" d="M314.62,25.13H43.44c-15.34,0-27.83,12.48-27.83,27.83s12.49,27.83,27.83,27.83h271.18c15.34,0,27.82-12.49,27.82-27.83s-12.48-27.83-27.82-27.83Z"/>
<path class="cls-50" d="M314.62,25.81H43.44c-14.97,0-27.15,12.18-27.15,27.15s12.18,27.15,27.15,27.15h271.18c14.97,0,27.15-12.18,27.15-27.15s-12.18-27.15-27.15-27.15Z"/>
<path class="cls-68" d="M314.62,26.48H43.44c-14.59,0-26.47,11.88-26.47,26.48s11.88,26.47,26.47,26.47h271.18c14.59,0,26.47-11.88,26.47-26.47s-11.87-26.48-26.47-26.48Z"/>
<path class="cls-49" d="M314.62,27.16H43.44c-14.22,0-25.8,11.57-25.8,25.8s11.58,25.8,25.8,25.8h271.18c14.22,0,25.79-11.58,25.79-25.8s-11.57-25.8-25.79-25.8Z"/>
<path class="cls-83" d="M314.62,27.84H43.44c-13.84,0-25.12,11.27-25.12,25.12s11.27,25.12,25.12,25.12h271.18c13.85,0,25.11-11.27,25.11-25.12s-11.26-25.12-25.11-25.12Z"/>
<path class="cls-70" d="M314.62,28.52H43.44c-13.47,0-24.44,10.97-24.44,24.44s10.97,24.44,24.44,24.44h271.18c13.47,0,24.43-10.97,24.43-24.44s-10.96-24.44-24.43-24.44Z"/>
<path class="cls-87" d="M314.62,29.2H43.44c-13.1,0-23.76,10.66-23.76,23.76s10.67,23.76,23.76,23.76h271.18c13.1,0,23.75-10.66,23.75-23.76s-10.65-23.76-23.75-23.76Z"/>
<path class="cls-78" d="M314.62,29.88H43.44c-12.72,0-23.08,10.36-23.08,23.08s10.36,23.08,23.08,23.08h271.18c12.72,0,23.07-10.36,23.07-23.08s-10.35-23.08-23.07-23.08Z"/>
<path class="cls-69" d="M314.62,30.56H43.44c-12.35,0-22.41,10.05-22.41,22.4s10.06,22.41,22.41,22.41h271.18c12.35,0,22.39-10.06,22.39-22.41s-10.05-22.4-22.39-22.4Z"/>
<path class="cls-81" d="M314.62,31.23H43.44c-11.97,0-21.73,9.75-21.73,21.72s9.75,21.73,21.73,21.73h271.18c11.97,0,21.72-9.75,21.72-21.73s-9.74-21.72-21.72-21.72Z"/>
</g>
<g class="cls-48">
<path d="M314.62,20.38H43.44c-17.96,0-32.58,14.61-32.58,32.58s14.61,32.58,32.58,32.58h271.18c17.96,0,32.57-14.61,32.57-32.58s-14.61-32.58-32.57-32.58Z"/>
<path class="cls-85" d="M314.62,21.06H43.44c-17.59,0-31.9,14.31-31.9,31.91s14.31,31.9,31.9,31.9h271.18c17.59,0,31.9-14.31,31.9-31.9s-14.31-31.91-31.9-31.91Z"/>
<path class="cls-67" d="M314.62,21.74H43.44c-17.21,0-31.22,14-31.22,31.23s14.01,31.22,31.22,31.22h271.18c17.21,0,31.22-14.01,31.22-31.22s-14-31.23-31.22-31.23Z"/>
<path class="cls-60" d="M314.62,22.41H43.44c-16.84,0-30.54,13.7-30.54,30.55s13.7,30.54,30.54,30.54h271.18c16.84,0,30.54-13.7,30.54-30.54s-13.7-30.55-30.54-30.55h0Z"/>
<path class="cls-63" d="M314.62,23.09H43.44c-16.46,0-29.86,13.4-29.86,29.87s13.4,29.86,29.86,29.86h271.18c16.47,0,29.86-13.4,29.86-29.86s-13.39-29.87-29.86-29.87Z"/>
<path class="cls-54" d="M314.62,23.77H43.44c-16.09,0-29.19,13.09-29.19,29.19s13.1,29.19,29.19,29.19h271.18c16.09,0,29.18-13.09,29.18-29.19s-13.09-29.19-29.18-29.19Z"/>
<path class="cls-58" d="M314.62,24.45H43.44c-15.72,0-28.51,12.79-28.51,28.51s12.79,28.51,28.51,28.51h271.18c15.72,0,28.5-12.79,28.5-28.51s-12.79-28.51-28.5-28.51Z"/>
<path class="cls-86" d="M314.62,25.13H43.44c-15.34,0-27.83,12.48-27.83,27.83s12.49,27.83,27.83,27.83h271.18c15.34,0,27.82-12.49,27.82-27.83s-12.48-27.83-27.82-27.83Z"/>
<path class="cls-82" d="M314.62,25.81H43.44c-14.97,0-27.15,12.18-27.15,27.15s12.18,27.15,27.15,27.15h271.18c14.97,0,27.15-12.18,27.15-27.15s-12.18-27.15-27.15-27.15Z"/>
<path class="cls-56" d="M314.62,26.48H43.44c-14.59,0-26.47,11.88-26.47,26.48s11.88,26.47,26.47,26.47h271.18c14.59,0,26.47-11.88,26.47-26.47s-11.87-26.48-26.47-26.48Z"/>
<path class="cls-55" d="M314.62,27.16H43.44c-14.22,0-25.8,11.57-25.8,25.8s11.58,25.8,25.8,25.8h271.18c14.22,0,25.79-11.58,25.79-25.8s-11.57-25.8-25.79-25.8Z"/>
<path class="cls-88" d="M314.62,27.84H43.44c-13.84,0-25.12,11.27-25.12,25.12s11.27,25.12,25.12,25.12h271.18c13.85,0,25.11-11.27,25.11-25.12s-11.26-25.12-25.11-25.12Z"/>
<path class="cls-65" d="M314.62,28.52H43.44c-13.47,0-24.44,10.97-24.44,24.44s10.97,24.44,24.44,24.44h271.18c13.47,0,24.43-10.97,24.43-24.44s-10.96-24.44-24.43-24.44Z"/>
<path class="cls-80" d="M314.62,29.2H43.44c-13.1,0-23.76,10.66-23.76,23.76s10.67,23.76,23.76,23.76h271.18c13.1,0,23.75-10.66,23.75-23.76s-10.65-23.76-23.75-23.76Z"/>
<path class="cls-74" d="M314.62,29.88H43.44c-12.72,0-23.08,10.36-23.08,23.08s10.36,23.08,23.08,23.08h271.18c12.72,0,23.07-10.36,23.07-23.08s-10.35-23.08-23.07-23.08Z"/>
<path class="cls-72" d="M314.62,30.56H43.44c-12.35,0-22.41,10.05-22.41,22.4s10.06,22.41,22.41,22.41h271.18c12.35,0,22.39-10.06,22.39-22.41s-10.05-22.4-22.39-22.4Z"/>
<path class="cls-57" d="M314.62,31.23H43.44c-11.97,0-21.73,9.75-21.73,21.72s9.75,21.73,21.73,21.73h271.18c11.97,0,21.72-9.75,21.72-21.73s-9.74-21.72-21.72-21.72Z"/>
</g>
</g>
<g>
<path class="cls-34" d="M84.69,14.97c0,7.48-6.07,13.55-13.56,13.55s-13.56-6.07-13.56-13.55,6.07-13.56,13.56-13.56,13.56,6.07,13.56,13.56Z"/>
<path class="cls-24" d="M84.69,14.97c0,7.49-6.07,13.55-13.56,13.55s-13.56-6.06-13.56-13.55,6.07-13.56,13.56-13.56,13.56,6.07,13.56,13.56Z"/>
</g>
<g>
<path class="cls-47" d="M102.4,14.97c0,5.35-4.34,9.69-9.69,9.69s-9.69-4.33-9.69-9.69,4.34-9.69,9.69-9.69,9.69,4.34,9.69,9.69Z"/>
<path class="cls-30" d="M102.4,14.97c0,5.35-4.34,9.69-9.69,9.69s-9.69-4.33-9.69-9.69,4.34-9.69,9.69-9.69,9.69,4.33,9.69,9.69Z"/>
</g>
<g>
<path class="cls-20" d="M129.26,14.96c0,8.27-6.7,14.96-14.97,14.96s-14.96-6.69-14.96-14.96S106.03,0,114.29,0s14.97,6.7,14.97,14.96Z"/>
<path class="cls-31" d="M129.26,14.96c0,8.27-6.7,14.96-14.97,14.96s-14.97-6.69-14.97-14.96S106.02,0,114.29,0s14.97,6.69,14.97,14.96Z"/>
</g>
<g>
<path class="cls-3" d="M147.13,14.97c0,6.22-5.04,11.25-11.25,11.25s-11.25-5.04-11.25-11.25,5.04-11.26,11.25-11.26,11.25,5.04,11.25,11.26Z"/>
<path class="cls-5" d="M147.13,14.97c0,6.22-5.04,11.25-11.25,11.25s-11.26-5.04-11.26-11.25,5.04-11.26,11.26-11.26,11.25,5.04,11.25,11.26Z"/>
</g>
<g>
<path class="cls-43" d="M172.18,14.97c0,8.13-6.59,14.73-14.73,14.73s-14.73-6.59-14.73-14.73S149.31.24,157.45.24s14.73,6.6,14.73,14.73Z"/>
<path class="cls-26" d="M172.18,14.97c0,8.13-6.59,14.72-14.73,14.72s-14.73-6.59-14.73-14.72S149.32.24,157.45.24s14.73,6.59,14.73,14.73Z"/>
</g>
<g>
<path class="cls-27" d="M188.83,14.97c0,5.41-4.39,9.79-9.79,9.79s-9.8-4.38-9.8-9.79,4.38-9.8,9.8-9.8,9.79,4.39,9.79,9.8Z"/>
<path class="cls-6" d="M188.83,14.97c0,5.41-4.39,9.79-9.79,9.79s-9.8-4.38-9.8-9.79,4.38-9.8,9.8-9.8,9.79,4.38,9.79,9.8Z"/>
</g>
<g>
<path class="cls-35" d="M209.61,14.97c0,4.97-4.03,9-9,9s-9-4.03-9-9,4.03-9,9-9,9,4.03,9,9Z"/>
<path class="cls-17" d="M209.61,14.97c0,4.97-4.03,8.99-9,8.99s-9-4.02-9-8.99,4.03-9,9-9,9,4.02,9,9Z"/>
</g>
<g>
<path class="cls-18" d="M236.83,14.97c0,8.09-6.56,14.64-14.64,14.64s-14.64-6.55-14.64-14.64S214.1.33,222.19.33s14.64,6.55,14.64,14.64Z"/>
<path class="cls-4" d="M236.83,14.97c0,8.09-6.56,14.64-14.64,14.64s-14.65-6.55-14.65-14.64S214.1.33,222.19.33s14.64,6.55,14.64,14.64Z"/>
</g>
<g>
<path class="cls-8" d="M254.37,14.96c0,5.85-4.74,10.6-10.6,10.6s-10.6-4.75-10.6-10.6,4.75-10.6,10.6-10.6,10.6,4.75,10.6,10.6Z"/>
<path class="cls-25" d="M254.37,14.96c0,5.85-4.74,10.6-10.6,10.6s-10.61-4.74-10.61-10.6,4.75-10.6,10.61-10.6,10.6,4.74,10.6,10.6Z"/>
</g>
<g>
<path class="cls-19" d="M276.09,14.97c0,5.93-4.8,10.73-10.74,10.73s-10.74-4.81-10.74-10.73,4.81-10.74,10.74-10.74,10.74,4.81,10.74,10.74Z"/>
<path class="cls-37" d="M276.09,14.97c0,5.93-4.8,10.73-10.74,10.73s-10.74-4.8-10.74-10.73,4.81-10.74,10.74-10.74,10.74,4.8,10.74,10.74Z"/>
</g>
<g>
<path class="cls-42" d="M299.04,14.96c0,6.68-5.42,12.1-12.1,12.1s-12.11-5.42-12.11-12.1,5.42-12.11,12.11-12.11,12.1,5.42,12.1,12.11Z"/>
<path class="cls-13" d="M299.04,14.96c0,6.69-5.42,12.1-12.1,12.1s-12.11-5.41-12.11-12.1,5.42-12.11,12.11-12.11,12.1,5.42,12.1,12.11Z"/>
</g>
<g>
<path class="cls-7" d="M316.93,14.97c0,4.65-3.77,8.43-8.43,8.43s-8.43-3.78-8.43-8.43,3.77-8.43,8.43-8.43,8.43,3.77,8.43,8.43Z"/>
<path class="cls-39" d="M316.93,14.97c0,4.66-3.77,8.43-8.43,8.43s-8.43-3.77-8.43-8.43,3.78-8.43,8.43-8.43,8.43,3.77,8.43,8.43Z"/>
</g>
<g>
<path class="cls-45" d="M57.99,14.96c0,4.66-3.77,8.43-8.43,8.43s-8.43-3.77-8.43-8.43,3.78-8.43,8.43-8.43,8.43,3.78,8.43,8.43Z"/>
<path class="cls-44" d="M57.99,14.96c0,4.66-3.77,8.43-8.43,8.43s-8.43-3.77-8.43-8.43,3.78-8.43,8.43-8.43,8.43,3.77,8.43,8.43Z"/>
</g>
<g>
<path class="cls-11" d="M351.9,32.62c0,2.96-2.4,5.36-5.36,5.36s-5.36-2.4-5.36-5.36,2.4-5.36,5.36-5.36,5.36,2.4,5.36,5.36Z"/>
<path class="cls-38" d="M351.9,32.62c0,2.96-2.4,5.36-5.36,5.36s-5.36-2.4-5.36-5.36,2.4-5.36,5.36-5.36,5.36,2.4,5.36,5.36Z"/>
</g>
<g>
<path class="cls-2" d="M354.92,52.62c0,1.71-1.39,3.1-3.1,3.1s-3.1-1.39-3.1-3.1,1.39-3.1,3.1-3.1,3.1,1.39,3.1,3.1Z"/>
<path class="cls-36" d="M354.92,52.62c0,1.71-1.39,3.1-3.1,3.1s-3.1-1.39-3.1-3.1,1.39-3.1,3.1-3.1,3.1,1.39,3.1,3.1Z"/>
</g>
<g>
<path class="cls-40" d="M350.33,75.09c0,2.47-2,4.47-4.47,4.47s-4.47-2-4.47-4.47,2-4.47,4.47-4.47,4.47,2,4.47,4.47Z"/>
<path class="cls-15" d="M350.33,75.09c0,2.47-2,4.47-4.47,4.47s-4.47-2-4.47-4.47,2-4.47,4.47-4.47,4.47,2,4.47,4.47Z"/>
</g>
<g>
<path class="cls-23" d="M335.52,18.07c0,2.47-2,4.47-4.47,4.47s-4.47-2-4.47-4.47,2-4.47,4.47-4.47,4.47,2,4.47,4.47Z"/>
<path class="cls-46" d="M335.52,18.07c0,2.47-2,4.47-4.47,4.47s-4.47-2-4.47-4.47,2-4.47,4.47-4.47,4.47,2,4.47,4.47Z"/>
</g>
<g>
<path class="cls-33" d="M333.31,88.67c0,2.34-1.9,4.24-4.24,4.24s-4.24-1.9-4.24-4.24,1.9-4.24,4.24-4.24,4.24,1.9,4.24,4.24Z"/>
<path class="cls-14" d="M333.31,88.68c0,2.34-1.9,4.23-4.24,4.23s-4.24-1.89-4.24-4.23,1.9-4.24,4.24-4.24,4.24,1.9,4.24,4.24Z"/>
</g>
<g>
<path class="cls-16" d="M7.03,32.62c0,2.61,2.12,4.73,4.73,4.73s4.73-2.12,4.73-4.73-2.12-4.73-4.73-4.73-4.73,2.12-4.73,4.73Z"/>
<path class="cls-29" d="M7.03,32.62c0,2.61,2.12,4.73,4.73,4.73s4.73-2.12,4.73-4.73-2.12-4.73-4.73-4.73-4.73,2.12-4.73,4.73Z"/>
</g>
<g>
<path class="cls-32" d="M3.47,52.62c0,1.71,1.39,3.1,3.1,3.1s3.1-1.39,3.1-3.1-1.39-3.1-3.1-3.1-3.1,1.39-3.1,3.1Z"/>
<path class="cls-21" d="M3.47,52.62c0,1.71,1.39,3.1,3.1,3.1s3.1-1.39,3.1-3.1-1.39-3.1-3.1-3.1-3.1,1.39-3.1,3.1Z"/>
</g>
<g>
<path class="cls-41" d="M8.06,75.09c0,2.47,2,4.47,4.47,4.47s4.47-2,4.47-4.47-2-4.47-4.47-4.47-4.47,2-4.47,4.47Z"/>
<path class="cls-10" d="M8.06,75.09c0,2.47,2,4.47,4.47,4.47s4.47-2,4.47-4.47-2-4.47-4.47-4.47-4.47,2-4.47,4.47Z"/>
</g>
<g>
<path class="cls-9" d="M22.87,18.07c0,2.47,2,4.47,4.47,4.47s4.47-2,4.47-4.47-2-4.47-4.47-4.47-4.47,2-4.47,4.47Z"/>
<path class="cls-1" d="M22.87,18.07c0,2.47,2,4.47,4.47,4.47s4.47-2,4.47-4.47-2-4.47-4.47-4.47-4.47,2-4.47,4.47Z"/>
</g>
<g>
<path class="cls-12" d="M25.08,88.67c0,2.34,1.9,4.24,4.24,4.24s4.24-1.9,4.24-4.24-1.9-4.24-4.24-4.24-4.24,1.9-4.24,4.24Z"/>
<path class="cls-28" d="M25.08,88.68c0,2.34,1.9,4.23,4.24,4.23s4.24-1.89,4.24-4.23-1.9-4.24-4.24-4.24-4.24,1.9-4.24,4.24Z"/>
</g>
</g>
</g>
</g>
</g>
</svg>
  <div className="wheel-jackpot-amount-text jackpot-mini-txt">${formattedMiniJackpot}</div>
</div>
</>
);

export default MiniJackpotAmount;
